import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getUnreadCount,
  listNotifications,
  markAllAsRead,
  markAsRead,
} from "@/features/notifications/api/notificationsApi";
import { useNotificationsStore } from "@/features/notifications/model/notificationsStore";

const ROOT_KEY = ["notifications"] as const;
const LIST_KEY = [...ROOT_KEY, "list"] as const;
const UNREAD_KEY = [...ROOT_KEY, "unread-count"] as const;

export function useUnreadCount() {
  return useQuery({
    queryKey: UNREAD_KEY,
    queryFn: getUnreadCount,
    // Polling: refresh every 30s while tab is visible. No WebSockets in Phase 1.
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    staleTime: 15_000,
  });
}

export function useNotificationList() {
  const drawerOpen = useNotificationsStore((s) => s.drawerOpen);
  return useQuery({
    queryKey: LIST_KEY,
    queryFn: () => listNotifications(20, 0),
    enabled: drawerOpen,
    staleTime: 10_000,
  });
}

export function useMarkAsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markAsRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: UNREAD_KEY });
      qc.invalidateQueries({ queryKey: LIST_KEY });
    },
  });
}

export function useMarkAllAsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => markAllAsRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: UNREAD_KEY });
      qc.invalidateQueries({ queryKey: LIST_KEY });
    },
  });
}
